import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';

import { CustomerContext } from 'context/customer';

import geocode from 'helpers/geocode';
import { logMparticleEvent, mParticleCustomEvents, mParticleEventTypes } from 'helpers/mParticle';

import { ModalContext } from 'context/modal';

import LoadingSpinner from 'components/designSystem/LoadingSpinner/LoadingSpinner';

import IconCurrentLocation from 'components/shared/SVG/IconCurrentLocation';

import ModalComponents from 'types/modals';

import styles from './LocateMeDropdown.module.scss';

function LocateMeDropdown({ hideDefaultDropdown, mparticleSource, onSelectAddress }) {
  const { user } = useContext(CustomerContext);
  const { showModal } = useContext(ModalContext);

  const [isLoading, setIsLoading] = useState(false);
  const mparticleLocation =
    mparticleSource === 'homepage'
      ? 'current_location_hero_search_bar'
      : 'current_location_search_listing_modal';

  const handleError = (err) => {
    if (err) {
      setIsLoading(false);
      hideDefaultDropdown();
      showModal({
        modalType: ModalComponents.LOCATION_LOOKUP_FAILED,
        modalProps: {
          errors: ['We were unable to determine your location. Please try again.'],
          shouldShowCloseIcon: false,
          designSystemModalStyle: 'alert',
        },
      });
    }
  };

  async function getPosition(position) {
    const { latitude, longitude } = position.coords || {};
    const result = await geocode({
      location: {
        lat: parseFloat(latitude, 10),
        lng: parseFloat(longitude, 10),
      },
    });

    logMparticleEvent({
      eventName: mParticleCustomEvents.performLocationSearch,
      eventType: mParticleEventTypes.Other,
      attributes: {
        source: mparticleSource,
        location: mparticleLocation,
        searched_location: result[0].formatted_address,
        searched_latitude: latitude.toString(),
        searched_longitude: longitude.toString(),
        user_is_authenticated: !!user,
      },
    });

    onSelectAddress(result[0]);
    hideDefaultDropdown();
  }

  const calculateCurrentPosition = () => {
    setIsLoading(true);
    window.navigator.geolocation.getCurrentPosition(getPosition, handleError);
  };

  return (
    <button type="button" onClick={calculateCurrentPosition} className={styles.currentLocation}>
      {isLoading && <LoadingSpinner size="small" />}
      {!isLoading && (
        <span className={styles.iconCurrentLocation}>
          <IconCurrentLocation />
        </span>
      )}
      <span className={styles.label}>Current Location</span>
    </button>
  );
}

LocateMeDropdown.propTypes = {
  hideDefaultDropdown: PropTypes.func.isRequired,
  onSelectAddress: PropTypes.func,
  mparticleSource: PropTypes.string.isRequired,
};

LocateMeDropdown.defaultProps = {
  onSelectAddress: null,
};

export default LocateMeDropdown;
